exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar[data-v-663767e8] {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  right: 0;\n  height: 56px;\n  line-height: 56px;\n  -webkit-box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);\n          box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);\n  background: #fff;\n  border-top: 1px solid #e8e8e8;\n  padding: 0 24px;\n  z-index: 9;\n}\n", ""]);

// exports
